import React from 'react';
import 'whatwg-fetch'
import {
    BrowserRouter as Router,
    Route,
    Switch
} from 'react-router-dom'
import './common/fonts.css';
import Loadable from 'react-loadable';
import {Howl} from "howler";

const Achievements = require('./spaceship/Achievements');
const Api = require('../api/api.js');
const BackgroundMusic = require('./common/BackgroundMusic');
const FilesToPreload = require('./common/FilesToPreload').Files;
const Loading = require('./common/Loading');
const moment = require('moment');
const Preload = require('react-preloaded').Preload;
const Rooms = require('./spaceship/Room').Rooms;
const Stats = require('./spaceship/Stats');
const DASHBOARD_URL = require('./common/Urls').DASHBOARD_URL;
const WEBSITE_URL = require('./common/Urls').WEBSITE_URL;

// LOADABLE ROUTES
const FollowingDirections = Loadable({
    loader: () => import('./following-directions/FollowDirections'),
    loading: Loading,
});
const HocusPocus = Loadable({
    loader: () => import('./hocus-pocus/HocusPocus'),
    loading: Loading,
});
const Home = Loadable({
    loader: () => import('./Home'),
    loading: Loading,
});
const ListeningLaunch = Loadable({
    loader: () => import('./listening-launch/ListeningLaunch'),
    loading: Loading,
});
const MilkyWay = Loadable({
    loader: () => import('./milky-way/MilkyWay'),
    loading: Loading,
});
const PatternPuzzler = Loadable({
    loader: () => import('./pattern-puzzler/PatternPuzzler'),
    loading: Loading,
});
const SelfControl = Loadable({
    loader: () => import('./self-control-black-hole/SelfControl'),
    loading: Loading,
});
const ShoppingPlanet = Loadable({
    loader: () => import('./spaceship/ShoppingPlanet'),
    loading: Loading,
});
const Spaceship = Loadable({
    loader: () => import('./spaceship/Spaceship'),
    loading: Loading,
});
const TestMyBrain = Loadable({
    loader: () => import('./test-my-brain/TestMyBrain'),
    loading: Loading,
});
const ThinkingUniverse = Loadable({
    loader: () => import('./thinking-universe/ThinkingUniverse'),
    loading: Loading,
});



class App extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loggedIn: false,
            imagesLoaded: false,
            studentLoaded: false,
            loginError: false,
            username: '',
            password: '',
            homeMounted: 0,
            studentData: {},
            music: "/assets/common/audio/music/home.mp3",
            playMusic: true,
            chatboxAudioID: null,
            homeLoadTime: 0,
            testMyBrain: false,
            chooseStudent: false,
            hasActiveUser: false,
            chatboxVolume: 1,
            scoreNeededForCompletion: 50,
            autoPlayAudio: true,
            muted: false,
            finishedLevel: false,
        };

        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
        this.updateStudent = this.updateStudent.bind(this);
        this.setStudent = this.setStudent.bind(this);
        this.setHomeMounted = this.setHomeMounted.bind(this);
        this.updateMusic = this.updateMusic.bind(this);
        this.setAchievements = this.setAchievements.bind(this);
        this.setMusicVolume = this.setMusicVolume.bind(this);
        this.setChatboxAudioID = this.setChatboxAudioID.bind(this);
        this.setChatboxAudioOnEnd = this.setChatboxAudioOnEnd.bind(this);
        this.addStudentPrizes = this.addStudentPrizes.bind(this);
        this.muteAudio = this.muteAudio.bind(this);
        this.toggleAudio = this.toggleAudio.bind(this);
        this.unMuteAudio = this.unMuteAudio.bind(this);
        this.pauseQuestionAudio = this.pauseQuestionAudio.bind(this);
        this.playQuestionAudio = this.playQuestionAudio.bind(this);
        this.replayQuestionAudio = this.replayQuestionAudio.bind(this);
        this.mobileStart = this.mobileStart.bind(this);
        this.completeLevel = this.completeLevel.bind(this);
        this.setTMB = this.setTMB.bind(this);
    }

    componentWillMount() {
        this.getUserData();
        this.getStudentData();
    }

    componentDidMount() {
        let self = this;
        this.setFontSize();
        window.addEventListener("resize", this.setFontSize);
        window.addEventListener("blur", function() {
            self.muteAudio();
        });
        window.addEventListener('focus', function() {
            if (!self.state.muted) {
                self.unMuteAudio();
            }
        });
        if (/^((?!chrome|android|mobile).)*safari/i.test(navigator.userAgent)) {
            this.canAutoPlayAudio();
        }
    }

    canAutoPlayAudio() {
        let self = this;
        let mp3 = 'data:audio/mpeg;base64,/+MYxAAAAANIAUAAAASEEB/jwOFM/0MM/90b/+RhST//w4NFwOjf///PZu////9lns5GFDv//l9GlUIEEIAAAgIg8Ir/JGq3/+MYxDsLIj5QMYcoAP0dv9HIjUcH//yYSg+CIbkGP//8w0bLVjUP///3Z0x5QCAv/yLjwtGKTEFNRTMuOTeqqqqqqqqqqqqq/+MYxEkNmdJkUYc4AKqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq';

        let ogg = 'data:audio/ogg;base64,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';

        try {
            let audio = new Audio();

            // this will only be triggered if autoplay works
            audio.src = audio.canPlayType('audio/ogg') ? ogg : mp3;
            let promise = audio.play();
            if (promise !== undefined) {
                promise.then(_ => {
                    // Autoplay started!
                    self.setState({
                        autoPlayAudio: true
                    });
                    audio.pause();
                }).catch(error => {
                    // Autoplay was prevented.
                    // Show a "Play" button so that user can start playback.
                    self.setState({
                        autoPlayAudio: false
                    });
                });
            }
        } catch(e) {
            console.log('[AUTOPLAY-ERROR]', e);
        }
    }

    getUserData() {
        let self = this;
        Api('GET', 'user/', {}, function (data) {
            let hasActiveUser = false;
            if (data.results.length) {
                if (data.results[0].is_staff) {
                    hasActiveUser = true;
                }
                if (data.results[0].subscriptions.length) {
                    for (let n in data.results[0].subscriptions) {
                        if (parseInt(data.results[0].subscriptions[n].status) === 1) {
                            hasActiveUser = true;
                        }
                        if (data.results[0].subscriptions[n].sub_expdate &&
                            moment(data.results[0].subscriptions[n].sub_expdate).diff(moment(), 'days') > 0) {
                            hasActiveUser = true;
                        }
                    }
                }
            }
            if (hasActiveUser) {
                window.dataLayer.push({
                    user_id: data.results[0].id
                });
                self.setState({
                    hasActiveUser: hasActiveUser,
                    userId: data.results[0].id,
                    loggedIn: true
                });
            } else {
                window.location.href = WEBSITE_URL + 'buy-now/?redirected=1'
            }
        }, function(e) {
            window.location.href = WEBSITE_URL + 'login/?destination=app'
        });
    }

    getStudentData() {
        let self = this;
        Api('GET', 'student/', {}, function (data) {
            if (data.results.length) {
                if (data.results.length === 1) {
                    if (data.results) {
                        self.setStudent(data.results[0]);
                        self.state.allStudentData = data.results;
                    } else {
                        window.location.href = DASHBOARD_URL + 'children/?redirected=1'
                    }
                } else {
                    self.setState({
                        chooseStudent: true,
                        allStudentData: data.results
                    });
                }
            } else {
                window.location.href = DASHBOARD_URL + 'children/?redirected=1'
            }
        }, function() {
            window.location.href = DASHBOARD_URL + 'children/?redirected=1'
        });
    }

    toggleAudio() {
        if (this.state.muted) {
            this.unMuteAudio();
            this.state.muted = false;
        } else {
            this.muteAudio();
            this.state.muted = true;
        }
        $('#muteAudio').toggleClass('off');
    }

    muteAudio() {
        this.setState({
            musicVolume: 0,
            chatboxVolume: 0
        });

        if (this.state.chatboxAudioID) {
            this.state.chatboxAudioID.volume(0);
        }
        if (this.state.questionAudio) {
            this.state.questionAudio.volume(0);
        }
    }

    unMuteAudio() {
        this.setState({
            musicVolume: 0.1,
            chatboxVolume: 1
        });

        if (this.state.chatboxAudioID) {
            this.state.chatboxAudioID.volume(1);
        }
        if (this.state.questionAudio) {
            this.state.questionAudio.volume(1);
        }
    }

    pauseQuestionAudio() {
        if (this.state.questionAudio) {
            this.state.questionAudio.pause();
            this.state.questionAudio.unload();
        }
    }

    playQuestionAudio(audioFile) {
        let self = this;
        self.state.questionAudio = new Howl({
            src: [audioFile],
            onload: function() {
                self.state.questionAudio.play();
            },
            volume: self.state.chatboxVolume,
        });
    }

    replayQuestionAudio() {
        if (this.state.questionAudio) {
            this.state.questionAudio.pause();
            this.state.questionAudio.seek(0);
            this.state.questionAudio.play();
        }
    }

    setFontSize() {
        let app = document.getElementById('app');
        app.style.fontSize = app.offsetWidth * .01 +  'px';
    }

    setHomeMounted() {
        let date = new Date().getTime();
        this.setState({
            homeMounted: 1,
            homeLoadTime: Math.floor(date / 1000)
        });
    }

    setAchievements(data) {
        let achievements = {};
        let achievementsById = {};
        for (let n in data.results) {
            if (data.results.hasOwnProperty(n)) {
                let result = data.results[n];
                achievementsById[result.id] = result;
                if (result.reward_reason !== null) {
                    if (!achievements.hasOwnProperty(result.reward_reason)) {
                        achievements[result.reward_reason] = {};
                    }
                    if (result.game_name !== null) {
                        if (!achievements[result.reward_reason].hasOwnProperty(result.game_name)) {
                            achievements[result.reward_reason][result.game_name] = {};
                        }
                        if (result.difficulty !== null) {
                            if (!achievements[result.reward_reason][result.game_name].hasOwnProperty(result.difficulty)) {
                                achievements[result.reward_reason][result.game_name][result.difficulty] = {};
                            }
                            if (result.reward_value) {
                                if (!achievements[result.reward_reason][result.game_name][result.difficulty].hasOwnProperty(result.reward_value)) {
                                    achievements[result.reward_reason][result.game_name][result.difficulty][result.reward_value] = result;
                                }
                            } else {
                                achievements[result.reward_reason][result.game_name][result.difficulty] = result;
                            }
                        } else {
                            if (!achievements[result.reward_reason][result.game_name].hasOwnProperty('all')) {
                                achievements[result.reward_reason][result.game_name]['all'] = {};
                            }
                            if (result.reward_value) {
                                if (!achievements[result.reward_reason][result.game_name]['all'].hasOwnProperty(result.reward_value)) {
                                    achievements[result.reward_reason][result.game_name]['all'][result.reward_value] = result;
                                }
                            } else {
                                achievements[result.reward_reason][result.game_name]['all'] = result;
                            }
                        }
                    } else {
                        if (!achievements[result.reward_reason].hasOwnProperty('global')) {
                            achievements[result.reward_reason]['global'] = {};
                        }
                        if (result.difficulty !== null) {
                            if (!achievements[result.reward_reason]['global'].hasOwnProperty(result.difficulty)) {
                                achievements[result.reward_reason]['global'][result.difficulty] = {};
                            }
                            if (!achievements[result.reward_reason]['global'][result.difficulty].hasOwnProperty(result.reward_value)) {
                                achievements[result.reward_reason]['global'][result.difficulty][result.reward_value] = result;
                            }
                        } else {
                            if (!achievements[result.reward_reason]['global'].hasOwnProperty('all')) {
                                achievements[result.reward_reason]['global']['all'] = {};
                            }
                            if (!achievements[result.reward_reason]['global']['all'].hasOwnProperty(result.reward_value)) {
                                achievements[result.reward_reason]['global']['all'][result.reward_value] = result;
                            }
                        }
                    }
                }
            }
        }

        this.setState({
            achievements: achievements,
            achievementsById: achievementsById,
            studentLoaded: true,
        })
    }

    handleEmailChange(e) {
        this.state.username = e.target.value;
    }

    handlePasswordChange(e) {
        this.state.password = e.target.value;
    }

    setStudent(data) {
        Api('GET', 'achievement/', {'limit': 1000}, this.setAchievements);

        let p = this.getPrizes(data);

        let achievements = {};
        for (let a in data.achievements) {
            if (data.achievements.hasOwnProperty(a)) {
                achievements[data.achievements[a].id] = data.achievements[a];
            }
        }

        console.log('Student ID: ' + data.id);

        let studentData = {
            'id': data.id,
            'gems': data.gems,
            'grade': data.grade.numeric,
            'prizes': p[0],
            'prizeIds': p[1],
            'gems_spent': p[2],
            'achievements': achievements,
            'assessments': data.assessments,
            'total_questions': data.total_questions,
            'total_results': data.total_results,
            'finishedLevel': false,
        };

        window.dataLayer.push({
            student_id: data.id,
        });

        this.setState({
            studentData: studentData,
            chooseStudent: false,
            studentLoaded: true,
        });
    }

    getPrizes(data) {
        let gems_spent = 0;

        let prizeIds = '';
        let prizes = {
            placed: {},
            available: []
        };

        for (let r in Rooms) {
            if (Rooms.hasOwnProperty(r)) {
                prizes.placed[Rooms[r].path] = [];
            }
        }

        if (typeof data.prizes !== 'undefined') {
            for (let p in data.prizes) {
                if (data.prizes.hasOwnProperty(p)) {
                    if (data.prizes[p].placed) {
                        prizes.placed[data.prizes[p].room].push(data.prizes[p]);
                    } else {
                        prizes.available.unshift(data.prizes[p]);
                    }
                    gems_spent += data.prizes[p].prize.gem_cost;
                    prizeIds += data.prizes[p].prize.id + ',';
                }
            }
        }

        return [prizes, prizeIds, gems_spent];
    }

    updateStudent(data) {
        let self = this;
        let studentData = this.state.studentData;
        let postData = {};
        if (typeof data.gems !== 'undefined') {
            studentData['gems'] = data.gems;
            postData['gems'] = data.gems;
        }

        if (typeof data.achievements !== 'undefined') {
            postData['achievements'] = [data.achievements];
            studentData['achievements'][data.achievements] = this.state.achievementsById[data.achievements];
        }

        if (postData) {
            Api('PATCH', 'student/' + this.state.studentData.id + '/', postData);
        }

        if (typeof data.prizes !== 'undefined') {
            let p = this.getPrizes(data);
            studentData['prizes'] = p[0];
            studentData['gems_spent'] = p[1];
        } else if (typeof data.gems_spent !== 'undefined') {
            studentData['gems_spent'] = data.gems_spent;
        }

        if (data['total_questions']) {
            studentData['total_questions'] = data['total_questions'];
        }

        if (data['assessments']) {
            studentData.assessments.push(data['assessments']);
        }

        this.setState({
            studentData: studentData,
        });

        let testMyBrain = false;
        if (parseInt(localStorage.getItem('tmbCount_' + this.state.studentData.id)) > 4 &&
            parseInt(localStorage.getItem('tmbCount_' + this.state.studentData.id)) <= 6) {
            if (this.state.finishedLevel &&
                new Date().getTime() - localStorage.getItem('childStartTime_' + this.state.studentData.id) >= 600000) {
                if (data['total_results']) {
                    studentData['total_results'] = data['total_results'];
                    if (Math.floor(parseInt(studentData['total_results']) / 10) === parseInt(studentData['total_results']) / 10) {
                        testMyBrain = true;
                        localStorage.setItem('tmbCount_' + this.state.studentData.id,
                            parseInt(localStorage.getItem('tmbCount_' + this.state.studentData.id)) + 1);
                    }
                }
            }
        }
        self.setTMB(testMyBrain);
    }

    addStudentPrizes(prize) {
        let studentData = this.state.studentData;
        studentData.prizes.available.unshift(prize);
        this.setState({
            studentData: studentData
        });
    }

    updateMusic(audioFile, playMusic) {
        this.setState({
            'music': audioFile,
            'playMusic': playMusic
        })
    }

    setMusicVolume(volume) {
        if (!this.state.muted) {
            this.setState({
                'musicVolume': volume
            });
        }
    }

    setChatboxAudioID(id, callback) {
        this.setState({
            chatboxAudioID: id
        }, function(){
            if (typeof callback === 'function') {
                callback();
            }
        });

    }

    setChatboxAudioOnEnd(callback) {
        this.state.chatboxAudioID.off('end');
        this.state.chatboxAudioID.on('end', callback);
    }

    mobileStart() {
        this.setState({
            autoPlayAudio: true
        });
    }

    completeLevel(completion) {
        let self = this;
        this.setState({finishedLevel: completion},
        function () {
            let testMyBrain = false;
            if (parseInt(localStorage.getItem('tmbCount_' + this.state.studentData.id)) <= 4) {
                if (this.state.finishedLevel) {
                    if (((parseInt(localStorage.getItem('tmbCount_' + this.state.studentData.id)) === 0) &&
                        new Date().getTime() - localStorage.getItem('childStartTime_' + this.state.studentData.id) >= 600000)
                        || (parseInt(localStorage.getItem('tmbCount_' + this.state.studentData.id)) > 0 &&
                            parseInt(localStorage.getItem('tmbCount_' + this.state.studentData.id)) < 5
                            && new Date().getTime() - parseInt(localStorage.getItem('prevTMB_' + this.state.studentData.id)) >= 3600000)) {
                        testMyBrain = true;
                        localStorage.setItem('prevTMB_' + this.state.studentData.id, new Date().getTime().toString());
                        this.setState({
                            finishedLevel: false
                        });
                        localStorage.setItem('tmbCount_' + this.state.studentData.id,
                            parseInt(localStorage.getItem('tmbCount_' + this.state.studentData.id)) + 1);
                    }
                }
                self.setTMB(testMyBrain);
            }
        });
    }

    setTMB(testMyBrain) {
        this.setState({
            testMyBrain: testMyBrain
        });
    }

    DefaultComponent(props, Component) {
        return <Component
            loggedIn={this.state.loggedIn}
            updateStudent={this.updateStudent}
            setStudent={this.setStudent}
            studentData={this.state.studentData}
            history={props.history}
            updateMusic={this.updateMusic}
            achievements={this.state.achievements}
            achievementsById={this.state.achievementsById}
            setMusicVolume={this.setMusicVolume}
            setChatboxAudioID={this.setChatboxAudioID}
            chatboxAudioID={this.state.chatboxAudioID}
            setChatboxAudioOnEnd={this.setChatboxAudioOnEnd}
            addStudentPrizes={this.addStudentPrizes}
            homeLoadTime={this.state.homeLoadTime}
            homeMounted={this.state.homeMounted}
            testMyBrain={this.state.testMyBrain}
            chatboxVolume={this.state.chatboxVolume}
            scoreNeededForCompletion={this.state.scoreNeededForCompletion}
            musicVolume={this.state.musicVolume}
            playQuestionAudio={this.playQuestionAudio}
            pauseQuestionAudio={this.pauseQuestionAudio}
            replayQuestionAudio={this.replayQuestionAudio}
            completeLevel={this.completeLevel}
            setTMB={this.setTMB}
            tmbCount={parseInt(localStorage.getItem('tmbCount_' + this.state.studentData.id))}
        />
    }

    render() {
        let self = this;
        let key = -1;

        return (
            <Preload
                loadingIndicator={<Loading/>}
                images={FilesToPreload}
            >
                <Router>
                    <div id="react-container">
                        <BackgroundMusic
                            audioFile={this.state.music}
                            playMusic={this.state.playMusic}
                            volume={this.state.musicVolume}
                        />
                        {!self.state.hasActiveUser || (!self.state.studentLoaded && !self.state.chooseStudent) ?
                            <Loading />
                            :
                            <div className="topLeft100">
                            <Switch>
                                <Route path="/milky-way-memory" render={(props) => (
                                    this.DefaultComponent(props, MilkyWay)
                                )}/>
                                <Route path="/self-control-black-hole" render={(props) => (
                                    this.DefaultComponent(props, SelfControl)
                                )}/>
                                <Route path="/hocus-pocus" render={(props) => (
                                    this.DefaultComponent(props, HocusPocus)
                                )}/>
                                <Route path="/listening-launch" render={(props) => (
                                    this.DefaultComponent(props, ListeningLaunch)
                                )}/>
                                <Route path="/thinking-universe" render={(props) => (
                                    this.DefaultComponent(props, ThinkingUniverse)
                                )}/>
                                <Route path="/test-my-brain" render={(props) => (
                                    this.DefaultComponent(props, TestMyBrain)
                                )}/>
                                <Route path="/flying-following-directions" render={(props) => (
                                    this.DefaultComponent(props, FollowingDirections)
                                )}/>
                                <Route path="/planet-pattern-puzzler" render={(props) => (
                                    this.DefaultComponent(props, PatternPuzzler)
                                )}/>
                                <Route path="/spaceship" render={(props) => (
                                    this.DefaultComponent(props, Spaceship)
                                )}/>
                                <Route path="/shopping-planet" render={(props) => (
                                    this.DefaultComponent(props, ShoppingPlanet)
                                )}/>
                                <Route path="/stats" render={(props) => (
                                    this.DefaultComponent(props, Stats)
                                )}/>
                                <Route path="/achievements" render={(props) => (
                                    this.DefaultComponent(props, Achievements)
                                )}/>
                                {Rooms.map(function (r) {
                                    let path = '/spaceship-' + r.path;
                                    key++;
                                    r.key = key;
                                    return (
                                        <Route key={key} path={path} render={(props) => (
                                            <Spaceship
                                                studentData={self.state.studentData}
                                                updateStudent={self.updateStudent}
                                                setStudent={self.setStudent}
                                                path={r.path}
                                                room={r.name}
                                                roomKey={r.key}
                                                loggedIn={self.state.loggedIn}
                                                history={props.history}
                                                updateMusic={self.updateMusic}
                                                chatboxVolume={self.state.chatboxVolume}
                                                homeMounted={self.state.homeMounted}
                                            />
                                        )}/>
                                    );
                                })}
                                <Route render={(props) => (
                                    <div>
                                    {this.state.autoPlayAudio &&
                                    <Home
                                        studentData={self.state.studentData}
                                        updateStudent={self.updateStudent}
                                        setStudent={self.setStudent}
                                        handler={this.loginUser}
                                        loginError={this.state.loginError}
                                        usernameChange={this.handleEmailChange}
                                        passwordChange={this.handlePasswordChange}
                                        loggedIn={this.state.loggedIn}
                                        homeMounted={this.state.homeMounted}
                                        setHomeMounted={this.setHomeMounted}
                                        updateMusic={this.updateMusic}
                                        chooseStudent={this.state.chooseStudent}
                                        allStudentData={this.state.allStudentData}
                                        setChatboxAudioID={this.setChatboxAudioID}
                                        chatboxVolume={this.state.chatboxVolume}
                                    />
                                    }
                                    {!this.state.autoPlayAudio && <CantAutoPlayAudio mobileStart={this.mobileStart} />}
                                    </div>
                                )}/>
                            </Switch>
                                {this.state.autoPlayAudio && <button id="muteAudio" onClick={this.toggleAudio} /> }
                            </div>
                        }
                    </div>
                </Router>
            </Preload>
        )

    }
}

function CantAutoPlayAudio(props) {
    return (
        <div id="home" className="cant-auto-play">
            <div>
                <h1>Welcome to the GoGoBrain Galaxy!</h1>
                <p onClick={props.mobileStart}>Get Started</p>
            </div>
        </div>
    )
}

module.exports = App;
